import { theme } from 'antd'
import { observer } from 'mobx-react-lite'

import { DashboardStatTile, StatGrid } from '@/Ship/Components/Dashboard/DashboardStatTile'
import { Panel } from '@/Ship/Components/Dashboard/Overview/shared'
import { formatMoneyWithCurrency } from '@/Ship/Helpers/formatNumber'
import { dashboardManager } from '@/Ship/Stores/DashboardManager'

/** Гроші віджетів — у базовій валюті тенанта, гривні (`SPEC-027` §3.3). */
export const DASHBOARD_CURRENCY = 'UAH'

/**
 * Підписи — дослівно з легасі (`translation.json:604-605,617-620`), крім
 * опечатки «пробуток» → «прибуток» (D-23, Q3.8).
 */
export const LOADINGS_TILES = {
    loadingToday: 'Завантаження сьогодні',
    loadingWeek: 'Завантаження на поточному тижні',
    loadingMonth: 'Завантаження в поточному місяці',
    unloadingMonth: 'Фактичне розвантаження в поточному місяці',
    unloadingPlannedMonth: 'Планове розвантаження в поточному місяці',
    expectedProfit: 'Очікуваний прибуток в поточному місяці',
} as const

type CountKey = Exclude<keyof typeof LOADINGS_TILES, 'expectedProfit'>

const COUNT_KEYS: ReadonlyArray<CountKey> = [
    'loadingToday',
    'loadingWeek',
    'loadingMonth',
    'unloadingMonth',
    'unloadingPlannedMonth',
]

/**
 * «Завантаження й розвантаження» (`SPEC-027` §2.4, §3.5): заявки, де
 * співробітник — менеджер або відповідальний (ЗВ-10), не програні. «Планове
 * розвантаження» — за «Дата розвантаження (ПЛАН)» (ЗВ-11, Q3.6). Прибуток
 * зеленим. Бачать усі.
 */
export const TransportLoadingsTiles = observer(() => {
    const { token } = theme.useToken()
    const { transport, isTransportLoading } = dashboardManager
    const loadings = transport?.loadings

    return (
        <Panel
            block="transport-loadings"
            title="Завантаження й розвантаження"
            subtitle={dashboardManager.applicationsScopeLabel}
        >
            <StatGrid columns={6}>
                {COUNT_KEYS.map((key) => (
                    <DashboardStatTile
                        key={key}
                        tile={`loadings.${key}`}
                        title={LOADINGS_TILES[key]}
                        value={loadings?.[key]}
                        loading={isTransportLoading}
                    />
                ))}
                <DashboardStatTile
                    tile="loadings.expectedProfit"
                    title={LOADINGS_TILES.expectedProfit}
                    value={loadings ? formatMoneyWithCurrency(loadings.expectedProfit, DASHBOARD_CURRENCY) : null}
                    loading={isTransportLoading}
                    color={token.colorSuccess}
                />
            </StatGrid>
        </Panel>
    )
})
